import { render, staticRenderFns } from "./service-tag.vue?vue&type=template&id=2f7cde78&scoped=true&"
import script from "./service-tag.vue?vue&type=script&lang=js&"
export * from "./service-tag.vue?vue&type=script&lang=js&"
import style0 from "./service-tag.vue?vue&type=style&index=0&id=2f7cde78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7cde78",
  null
  
)

export default component.exports